import { sqliteTable, text, integer } from 'drizzle-orm/sqlite-core'
import { eq, desc, asc, and, or, like, gte, lt, sql } from 'drizzle-orm'

// Re-export commonly used operators
export { eq, desc, asc, and, or, like, gte, lt, sql }

// Users table
export const users = sqliteTable('users', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  namn: text('namn').notNull(),
  epost: text('epost'),
  telefon: text('telefon'),
  vouchers: integer('vouchers').notNull().default(0),
  completed_trainings: integer('completed_trainings').notNull().default(0),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
})

// Admin users table
export const adminUsers = sqliteTable('admin_users', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  username: text('username').notNull().unique(),
  password_hash: text('password_hash').notNull(),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
})

// Trainings table
export const trainings = sqliteTable('trainings', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  titel: text('titel').notNull(),
  beskrivning: text('beskrivning'),
  datum: text('datum').notNull(),
  location: text('location'),
  max_platser: integer('max_platser'),
  bootcamp: integer('bootcamp').notNull().default(0),
  bootcamp_id: integer('bootcamp_id'),
  free_training: integer('free_training').notNull().default(0),
  allow_non_bootcamp_join: integer('allow_non_bootcamp_join').notNull().default(0),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
  anmalda: integer('anmalda').notNull().default(0),
  bootcamp_name: text('bootcamp_name'),
})

// Attendance table
export const attendance = sqliteTable('attendance', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  training_id: integer('training_id').notNull(),
  user_id: integer('user_id').notNull(),
  present: integer('present').notNull().default(0),
  timestamp: text('timestamp').notNull().default('CURRENT_TIMESTAMP'),
})

// Voucher logs table
export const voucherLogs = sqliteTable('voucher_logs', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  user_id: integer('user_id').notNull(),
  admin_name: text('admin_name'),
  change_type: text('change_type').notNull(),
  amount: integer('amount').notNull(),
  training_id: integer('training_id'),
  training_title: text('training_title'),
  training_date: text('training_date'),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
})

// Bootcamps table
export const bootcamps = sqliteTable('bootcamps', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  name: text('name').notNull(),
  starts_at: text('starts_at'),
  ends_at: text('ends_at'),
  notes: text('notes'),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
})

// Subscriptions table
export const subscriptions = sqliteTable('subscriptions', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  user_id: integer('user_id').notNull(),
  training_id: integer('training_id').notNull(),
  completed: integer('completed').notNull().default(0),
  created_at: text('created_at').notNull().default('CURRENT_TIMESTAMP'),
})

// Type exports for compatibility
export type User = typeof users.$inferSelect
export type NewUser = typeof users.$inferInsert

export type AdminUser = typeof adminUsers.$inferSelect
export type NewAdminUser = typeof adminUsers.$inferInsert

export type Training = typeof trainings.$inferSelect
export type NewTraining = typeof trainings.$inferInsert

export type Attendance = typeof attendance.$inferSelect
export type NewAttendance = typeof attendance.$inferInsert

export type VoucherLog = typeof voucherLogs.$inferSelect
export type NewVoucherLog = typeof voucherLogs.$inferInsert

export type Bootcamp = typeof bootcamps.$inferSelect
export type NewBootcamp = typeof bootcamps.$inferInsert

export type Subscription = typeof subscriptions.$inferSelect
export type NewSubscription = typeof subscriptions.$inferInsert
